import React from 'react';
import {PtrnIcons} from '../../patronTypes';
import {SvgIconProps} from '@mui/material/SvgIcon';
import IconsMap from './PtrnIconsMap';
import NotFoundIcon from '@mui/icons-material/BrokenImage';

function PatronIcon({icon, ...other}: SvgIconProps & {icon: PtrnIcons}) {
   const SelectedIcon = IconsMap[icon];
   if (!SelectedIcon) {
      return <NotFoundIcon {...other} titleAccess="Icono no definido" />;
   }
   return <SelectedIcon {...other} />;
}

export default PatronIcon;
